export const getDynamicIconSize = (zoom: number) => {
  const baseSize = 23; // Base size of the icon in pixels
  const scaleFactor = 1; // Adjust this value to control scaling intensity
  const minZoom = 12; // Minimum zoom level

  // Calculate the size of the icon based on the zoom level
  return baseSize + (zoom - minZoom) * scaleFactor;
};

export const getDynamicBusLabelSize = (zoom: number) => {
  const baseFontSize = 10; // Base font size of the label in pixels
  const basePadding = 2; // Base padding of the label in pixels
  const scaleFactor = 1.5; // Adjust this value to control scaling intensity
  const minZoom = 12; // Minimum zoom level

  // Calculate the size of the label based on the zoom level
  return {
    // Calculate the font size and padding of the label based on the zoom level
    fontSize: baseFontSize + (zoom - minZoom) * scaleFactor,
    padding: basePadding + (zoom - minZoom) * scaleFactor,
  };
};
